import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { plateformSettingServices } from "../../../APIServices/PasswordManagement/plateformSettingServices";
import Swal from "sweetalert2";
import { BiReset } from "react-icons/bi";

const PrivacySettings = ({ auth, getSinglePlateformSettings, plateformSettings }) => {
  const [showPrivacySettings, setShowPrivacySettings] = useState("");
  const [privacySettings, setPrivacySettings] = useState("");
  const [loader, setLoader] = useState("");

  const addUpdatePlateformSettings = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} privacy setting?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(type);
        let userData = {};
        userData.privacySettings = type === "update" ? privacySettings : {};
        let data = await plateformSettingServices.addUpdatePlateformSettings(
          auth,
          userData
        );
        if (data?.statusCode === 200) {
          getSinglePlateformSettings();
        }
        setLoader("");
      }
    });
  };

  useEffect(() => {
    if (plateformSettings) {
      setPrivacySettings(plateformSettings?.settings?.privacySettings || "");
      setShowPrivacySettings(plateformSettings?.settings?.showPrivacySettings || "");
    }
  }, [plateformSettings]);

  const handleChange = (e) => {
    const { name, checked } = e.target;

    setPrivacySettings((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handlePrivacySettingsChange = (value) => {
    setPrivacySettings(prev =>
      Object.fromEntries(
        Object.keys(prev).map(key => [key, value])
      )
    );
  };

  let allSelected = Object.values(privacySettings).every(value => value === true);
  let noUpdate = Object.values(plateformSettings?.settings?.privacySettings).every(value => value === false);

  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Privacy Settings</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Form.Group className="mb-2" style={{ fontSize: 13 }}>
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  className="fw-bold"
                  checked={allSelected}
                  onChange={() => handlePrivacySettingsChange(!allSelected)}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowConfidentialsDataOption"
                  disabled={showPrivacySettings?.hideShowConfidentialsDataOption}
                  label="Hide/Show Confidentials Data Option (eg: Password, Key, etc.)"
                  checked={privacySettings?.hideShowConfidentialsDataOption && !showPrivacySettings?.hideShowConfidentialsDataOption}
                  onChange={handleChange}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowCopyOption"
                  disabled={showPrivacySettings?.hideShowCopyOption}
                  label="Copy Option (eg: Copy UserId, Copy Password, Copy Key, etc.)"
                  checked={privacySettings?.hideShowCopyOption && !showPrivacySettings?.hideShowCopyOption}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                If the checkbox is checked, the related options will be hidden; otherwise, when it is unchecked, the options will be visible on the platform.
              </Form.Label>
              <div className="hstack justify-content-end gap-2">
                {!noUpdate &&
                  <Button
                    disabled={loader}
                    onClick={() => addUpdatePlateformSettings("reset")}
                    variant="outline-danger"
                    style={{ fontSize: 13 }}
                    title="Reset"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BiReset /> Reset
                  </Button>
                }
                <Button
                  disabled={loader}
                  onClick={() => addUpdatePlateformSettings("update")}
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Update"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <FaRegEdit /> Update
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PrivacySettings;
